import type { User } from "@supabase/supabase-js";

import type { OverviewIdentity } from "../components/client/OverviewShell";

function makeInitials(s: string | null | undefined): string {
  if (!s?.trim()) return "??";
  const parts = s.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function buildClientIdentity(user: User | null): OverviewIdentity {
  const meta = (user?.user_metadata ?? {}) as Record<string, unknown>;
  const fullName =
    typeof meta.full_name === "string" && meta.full_name.trim()
      ? (meta.full_name as string).trim()
      : user?.email?.split("@")[0] ?? "Client";
  const company =
    typeof meta.company_name === "string" && (meta.company_name as string).trim()
      ? (meta.company_name as string)
      : "Your team";
  const roleTitle =
    typeof meta.role_title === "string" && (meta.role_title as string).trim()
      ? (meta.role_title as string).trim()
      : "";
  return {
    companyName: company,
    roleLine: roleTitle ? `${fullName} · ${roleTitle}` : fullName,
    initials: makeInitials(fullName),
  };
}
